module.exports = __webpack_public_path__ + "img/p29277.2137acaf.jpg";